import { Component, ViewChild } from '@angular/core';
import { AttendanceDeviceService } from '../../../Model/AttendanceDevice/attendance-device.service';
import { CommonService } from '../../../Model/Common/common.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { SessionService } from '../../../Util/Session/session.service';
import { ComboService } from '../../../Model/Combo/combo.service';

@Component({
  selector: 'app-emp-site-branch-mapping',
  standalone: true,
  imports: [DataTablesModule, CommonModule, FormsModule, RouterModule, NgSelectModule],
  templateUrl: './emp-site-branch-mapping.component.html',
  styleUrl: './emp-site-branch-mapping.component.scss'
})

export class EmpSiteBranchMappingComponent {
  isDisabled: boolean = false;
  dtTrigger: Subject<any> = new Subject<any>();
  //allSelect: boolean = false;
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  Data: any[] = [];
  Datas: any[] = [];
  filter = {
    SelectType: 2,
    ESS_SiteWiseDeviceDetailsID: 0,
  }

  WorkStatus = [] as any;
  WorkStatuValues = null;

  Details = {
    SelectType: null,
    ESS_SiteWiseDeviceDetailsID: null,
    CodeType: null,
    BranchSiteCode: null,
    DeviceSerialNumber: null,
    Module: null,
    empMasterId: null as any,
    isNotSync: false,
    CompanyCode: null,
  }

  dtoptions: DataTables.Settings = {};
  constructor(
    protected common: CommonService,
    private attendanceDevice: AttendanceDeviceService,
    private router: Router,
    private route: ActivatedRoute,
    private toast: ToastService,
    private modalService: NgbModal,
    private session: SessionService,
    private comboload: ComboService,
  ) {
    this.route.params.subscribe(params => this.filter.ESS_SiteWiseDeviceDetailsID = parseInt(params['id']));
    this.common.getPageRights();
    this.Details.CompanyCode = this.session.GetUserDetails().CompanyCode;
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ComboLoad('WorkStatusMaster');
    if (this.filter.ESS_SiteWiseDeviceDetailsID > 0) {
      this.ESS_SiteWiseDeviceDetailsSelect();
    }
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ESS_SiteWiseDeviceDetailsSelect() {
    this.isDisabled = true;
    this.attendanceDevice.ESS_SiteWiseDeviceDetailsSelect(this.filter).subscribe({
      next: (response) => {
        try {
          if (response.Table) {
            this.Datas = response.Table;
            this.Data = Object.values(response.Table);
          } else {
            this.Datas = [];
            this.Data = [];
          }

          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
        } catch (e) { }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  // ESS_EmpWiseSiteWiseDeviceDetails_Selectget() {
  //   this.isDisabled = true;
  //   this.Data = [];
  //   this.attendanceDevice.ESS_EmpWiseSiteWiseDeviceDetails_Selectget(this.filter).subscribe({
  //     next: (response) => {
  //       try {
  //         if (response.Table) {
  //           this.Data = Object.values(response.Table)
  //         }
  //         this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
  //           dtInstance.destroy();
  //           this.dtTrigger.next(null);
  //         });
  //       } catch (e) { }
  //       this.isDisabled = false;
  //     },
  //     complete: () => { },
  //     error: (error) => {
  //       this.isDisabled = false;
  //     },
  //   });
  // }

  async selectAll(event: any, IsAll: boolean) {
    const isChecked = event.target.checked;
    // this.Data.forEach((e) => {
    //   e.selected = isChecked;
    // });


    const checkboxes = document.getElementsByName('IsCheckAll') as NodeListOf<HTMLInputElement>;
    checkboxes.forEach(checkbox => {
      checkbox.checked = false;
    });
    (event.target as HTMLInputElement).checked = isChecked;

    try {
      const dt = await this.dtElement.dtInstance;
      const pageInfo = dt.page.info();
      const currentPage = pageInfo.page;
      const start = pageInfo.start;
      const end = pageInfo.end - 1;

      const updatedData = [...this.Data];

      if (IsAll) {
        updatedData.forEach(e => e.selected = isChecked);
      } else {
        updatedData.forEach(e => e.selected = false);
        for (let i = start; i <= end; i++) {
          if (updatedData[i]) {  // Safety check
            updatedData[i].selected = isChecked;
          }
        }
      }

      this.Data = updatedData;

      setTimeout(() => {
        if (this.dtElement?.dtInstance) {
          this.dtElement.dtInstance.then((dtInstance: any) => {
            dtInstance.page(currentPage).draw('page');
          });
        }
      }, 50);
    } catch (e) {
      console.error('Error in ARCheck:', e);
    }
  }

  SyncWithDevice() {
    //if (this.Data.filter(e => e.selected && !e.IsSync).length > 0) {
    if (this.Data.filter(e => e.selected).length > 0) {
      this.Details.CodeType = this.Data[0].CodeType;
      this.Details.BranchSiteCode = this.Data[0].BranchSiteCode;
      this.Details.DeviceSerialNumber = this.Data[0].DeviceSerialNumber;
      //this.Details.empMasterId = this.Data.filter(e => e.selected && !e.IsSync).map(e => e.EmpMasterID).toString();
      this.Details.empMasterId = this.Data.filter(e => e.selected).map(e => e.EmpMasterID).toString();
      this.Details.isNotSync = true;
      this.ESS_SiteWiseDeviceDetails_InsertUpdate();
    } else {
      this.toast.show({ message: "Please check atleast one unsync employee", type: toastTypeEnum.warning });
    }
  }

  UnSyncWithDevice() {
    if (this.Data.filter(e => e.selected && e.IsSync).length > 0) {
      this.Details.CodeType = this.Data[0].CodeType;
      this.Details.BranchSiteCode = this.Data[0].BranchSiteCode;
      this.Details.DeviceSerialNumber = this.Data[0].DeviceSerialNumber;
      this.Details.empMasterId = this.Data.filter(e => e.selected && e.IsSync).map(e => e.EmpMasterID).toString();
      this.Details.isNotSync = true;
      this.Ess_DeviceEmployeeDeletes();
    } else {
      this.toast.show({ message: "Please check atleast one sync employee", type: toastTypeEnum.warning });
    }
  }

  ESS_SiteWiseDeviceDetails_InsertUpdate() {
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to sync data (only unsync data will update)?';
    modalRef.result.then((result) => {
      if (result) {
        this.isDisabled = true;
        this.attendanceDevice.ESS_SiteWiseDeviceDetails_InsertUpdate(this.Details).subscribe({
          next: (response) => {
            if (response.Error_Code == '717') {
              const modalRef = this.modalService.open(AlertSuccessComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = response.Error_Message;
              modalRef.result.then((result: any) => {
                if (result) {
                  this.ESS_SiteWiseDeviceDetailsSelect();
                }
              });
            }
            else {
              const modalRef = this.modalService.open(AlertWarningComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = response.Error_Message;
              modalRef.result.then((result: any) => { });
            }

            this.isDisabled = false;
          },
          complete: () => { },
          error: (error) => {
            this.isDisabled = false;
          },
        });
      }
    });
  }

  Ess_DeviceEmployeeDeletes() {
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to unsync data (only sync data will update)?';
    modalRef.result.then((result) => {
      if (result) {
        this.isDisabled = true;
        this.attendanceDevice.Ess_DeviceEmployeeDeletes(this.Details).subscribe({
          next: (response) => {
            if (response.Error_Code == '727') {
              const modalRef = this.modalService.open(AlertSuccessComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = response.Error_Message;
              modalRef.result.then((result: any) => {
                if (result) {
                  this.ESS_SiteWiseDeviceDetailsSelect();
                }
              });
            }
            else {
              const modalRef = this.modalService.open(AlertWarningComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = response.Error_Message;
              modalRef.result.then((result: any) => { });
            }

            this.isDisabled = false;
          },
          complete: () => { },
          error: (error) => {
            this.isDisabled = false;
          },
        });
      }
    });
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    if (Combotype == 'WorkStatusMaster') {
      this.WorkStatus = [];
    }
    this.comboload.ComboLoad({ 'Combotype': Combotype }).subscribe({
      next: (response) => {
        if (response.ComboLoad) {
          if (Combotype == 'WorkStatusMaster') {
            this.WorkStatus = response.ComboLoad;
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  FilterStatusWise() {
    if (this.WorkStatuValues != null) {
      this.Data = Object.values(this.Datas.filter(e => e.EmployeeStatus == this.WorkStatuValues));
    } else {
      this.Data = Object.values(this.Datas);
    }

    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }
}
